import React, { useEffect } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Table,
  Badge,
} from "reactstrap"

//redux
import { useSelector, useDispatch } from "react-redux"
import withRouter from "components/Common/withRouter"

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb"

// actions
import { getAuthDetails } from "store/actions/usersAction"
import { ShimmerThumbnail } from "react-shimmer-effects"
import { useTranslation } from "react-i18next"

const UserProfile = () => {
  const { t } = useTranslation()
  //meta title
  document.title = t("Profile | Namq")

  const dispatch = useDispatch()

  const { loading, authDetails } = useSelector(state => state.Users)

  useEffect(() => {
    const getUserDetails = () => {
      dispatch(getAuthDetails())
    }
    getUserDetails()
  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title="Skote" breadcrumbItem="Profile" />
          <Row>
            <Col xl="12">
              <Card className="user_personal_info">
                <CardBody>
                  <CardTitle className="mb-4">
                    {t("Personal Information")}
                  </CardTitle>
                  <p className="text-muted mb-4"></p>
                  <div className="table-responsive">
                    {loading ? (
                      <ShimmerThumbnail height={450} rounded />
                    ) : Object.values(authDetails).length === 0 ? (
                      // <p className="text-center">No user found</p>
                      <div></div>
                    ) : (
                      <Table className="table-nowrap mb-0">
                        <tbody>
                          <tr>
                            <th scope="row">{t("Id")}</th>
                            <td>{authDetails._id}</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("First Name")}</th>
                            <td>{authDetails.firstName || "-"}</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Last Name")}</th>
                            <td>{authDetails.lastName || "-"}</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Account Type")}</th>
                            <td>{authDetails.accountType}</td>
                          </tr>

                          <tr>
                            <th scope="row">{t("Email")}</th>
                            <td>{authDetails.email}</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Role Id")}</th>
                            <td>{authDetails.role._id}</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Role")}</th>
                            <td>{authDetails.role.name}</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Status")}</th>
                            <td>
                              {authDetails?.role?.status === 1 ? (
                                <Badge className="bg-success">
                                  {t("Active")}
                                </Badge>
                              ) : (
                                <Badge className="bg-danger">
                                  {t("Deactive")}
                                </Badge>
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(UserProfile)
